import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class InventoryStatus extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  /**
   * Updates the inventory status display.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStatus = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStatus = event.detail.data.html.querySelector('inventory-status');

    if (!newStatus) return;

    morph(this, newStatus, { childrenOnly: true });
  };
}

if (!customElements.get('inventory-status')) {
  customElements.define('inventory-status', InventoryStatus);
}
